import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import eyeIcon from "../../assests/eyeIcon.svg";
import search from "../../assests/search.svg";
import leftArrow from "../../assests/leftArrow.svg";
import filter from "../../assests/filterIcon.svg";
import { Link, useNavigate } from "react-router-dom";
import "./UsersRoleList.css";
import Sidebar from "../Navigation/Sidebar/Sidebar";
import emotions7 from "../../assests/emotions7.svg";
import LoadingSpinner from "../Loading/component";

export const UsersroleList = (props) => {
  const [isFocused, setIsFocused] = useState(false);
  const navigate = useNavigate();

  const {
    displayList,
    Search,
    hasMore,
    loading,
    loadingMore,
    onLoadMore,
    searchData,
    roleList,
    handleRoleFilter,
    handleActiveClick,
    handleInactiveClick,
    handleAllStatusClick,
    handleClearFilters,
    isActive,
    selectedRoleName,
    selectedRoleFilter,
    filteredCount,
    tableContainerRef
  } = props;

  const addUser = () => navigate("/createuser");
  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);
  const arrowClick = () => navigate("/");

  const isFilterApplied = selectedRoleFilter !== null || isActive !== null || searchData;

  const getActiveFilterCount = () => {
    let count = 0;
    if (selectedRoleFilter) count++;
    if (isActive !== null) count++;
    if (searchData) count++;
    return count;
  };

  return (
    <div className="ur-main-container">
      <Sidebar />
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="ur-content-area">
          {/* Header Section */}
          <div className="ur-header-section">
            <button onClick={arrowClick} className="ur-back-btn">
              <img src={leftArrow} alt="Back" />
            </button>
            <h1 className="ur-page-title">Users & Roles</h1>
          </div>

          {/* Search and Add User Section */}
          <div className="ur-action-bar">
            <div className="ur-search-wrapper">
              <input
                type="search"
                placeholder="Search by Full Name / Mobile Number"
                onFocus={handleFocus}
                onBlur={handleBlur}
                onChange={(e) => Search(e.target.value)}
                value={searchData || ""}
                className="ur-search-input"
              />
              <img
                src={search}
                alt="Search"
                className={`ur-search-icon ${isFocused ? "ur-hidden" : ""}`}
              />
            </div>

            <Button onClick={addUser} className="ur-add-user-btn" variant="primary">
              + Add User
            </Button>
          </div>

          {/* Results Count */}
          <div className="ur-results-count">
            Showing {displayList.length} {filteredCount > 0 ? `of ${filteredCount}` : ''} users
          </div>

          {/* Table Section */}
          <div className="ur-table-container">
            <table className="ur-table">
              <thead>
                <tr>
                  <th className="ur-sno-col">Sr. No</th>
                  <th className="ur-name-col">Full Name</th>
                  <th className="ur-id-col">User ID</th>
                  <th className="ur-mobile-col">Mobile Number</th>
                  <th className="ur-role-col">
                    <div className="ur-header-content">
                      <span>Role</span>
                      <Dropdown align="end">
                        <Dropdown.Toggle variant="link" className="ur-filter-toggle">
                          <img src={filter} alt="Filter" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="ur-dropdown-menu">
                          <Dropdown.Item 
                            onClick={() => handleRoleFilter(null, "All Roles")}
                            className={!selectedRoleFilter ? "ur-active-filter-item" : ""}
                          >
                            All Roles
                          </Dropdown.Item>
                          <Dropdown.Divider />
                          {roleList?.map((el, index) => (
                            <Dropdown.Item
                              key={index}
                              onClick={() => handleRoleFilter(el.id, el.name)}
                              className={selectedRoleFilter === el.id ? "ur-active-filter-item" : ""}
                            >
                              {el.name}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </th>
                  <th className="ur-status-col">
                    <div className="ur-header-content">
                      <span>Status</span>
                      <Dropdown align="end">
                        <Dropdown.Toggle variant="link" className="ur-filter-toggle">
                          <img src={filter} alt="Filter" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="ur-dropdown-menu">
                          <Dropdown.Item 
                            onClick={handleAllStatusClick}
                            className={isActive === null ? "ur-active-filter-item" : ""}
                          >
                            All
                          </Dropdown.Item>
                          <Dropdown.Item 
                            onClick={handleActiveClick}
                            className={isActive === true ? "ur-active-filter-item" : ""}
                          >
                            Active
                          </Dropdown.Item>
                          <Dropdown.Item 
                            onClick={handleInactiveClick}
                            className={isActive === false ? "ur-active-filter-item" : ""}
                          >
                            Inactive
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </th>
                  <th className="ur-actions-col">Actions</th>
                </tr>
              </thead>
            </table>
            
            <div className="ur-table-body-wrapper" ref={tableContainerRef}>
              <table className="ur-table ur-table-body">
                <tbody>
                  {displayList?.length > 0 ? (
                    displayList.map((item, index) => (
                      <tr key={item.id} className="ur-table-row">
                        <td className="ur-sno">{index + 1}</td>
                        <td className="ur-fullname">{item.full_name}</td>
                        <td className="ur-userid">{item.id}</td>
                        <td className="ur-mobile">{item.mobile}</td>
                        <td>
                          <span className="ur-role-badge">
                            {item.user_role || "N/A"}
                          </span>
                        </td>
                        <td>
                          <span className={`ur-status-badge ${item.status !== "active" ? "ur-status-inactive" : "ur-status-active"}`}>
                            {item.status === "active" ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td className="ur-actions">
                          <Link to={`/users/userlist/${item.id}`} className="ur-view-link">
                            <img src={eyeIcon} alt="View" className="ur-view-icon" />
                          </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="ur-empty-row">
                        <div className="ur-empty-state">
                          <img src={emotions7} alt="No users found" className="ur-empty-icon" />
                          <p className="ur-empty-message">
                            {searchData 
                              ? `No users found matching "${searchData}"` 
                              : isFilterApplied 
                              ? "No users match the selected filters" 
                              : "No users found"}
                          </p>
                          {isFilterApplied && (
                            <button className="ur-clear-filters-large" onClick={handleClearFilters}>
                              Clear Filters
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                  
                  {/* Load More Button inside table body */}
                  {hasMore && displayList.length > 0 && (
                    <tr className="ur-load-more-row">
                      <td colSpan="7">
                        <div className="ur-load-more-container">
                          <button className="ur-load-more-btn" onClick={onLoadMore} disabled={loadingMore}>
                            {loadingMore ? (
                              <>
                                <span className="ur-spinner"></span>
                                Loading...
                              </>
                            ) : (
                              "Load More"
                            )}
                          </button>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};